import { createSlice } from '@reduxjs/toolkit';

const getInitialMode = () => {
  const savedMode = localStorage.getItem('themeMode');
  if (savedMode) return savedMode;
  
  // Check system preference
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
};

const initialState = {
  mode: getInitialMode(),
  sidebarOpen: false,
  sidebarPermanent: window.innerWidth >= 960,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      localStorage.setItem('themeMode', state.mode);
    },
    setThemeMode: (state, action) => {
      state.mode = action.payload;
      localStorage.setItem('themeMode', state.mode);
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setSidebarPermanent: (state, action) => {
      state.sidebarPermanent = action.payload;
    },
  },
});

export const { 
  toggleTheme, 
  setThemeMode, 
  toggleSidebar, 
  setSidebarOpen, 
  setSidebarPermanent 
} = uiSlice.actions;

export default uiSlice.reducer;